import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
	constructor(
		private translateService: TranslateService,
		private readonly title: Title
	) {
		super();
	}

	override updateTitle(routerState: RouterStateSnapshot): void {
		const title: string | undefined = this.buildTitle(routerState);
		if (title) {
			this.title.setTitle('Gránit Lakossági Hitel - ' + this.translateService.instant(title));
		} else {
			this.title.setTitle('Gránit Lakossági Hitel');
		}
	}
}
